// import { useEffect } from 'react';
// // @mui
// import Box from '@mui/material/Box';
// import Stack from '@mui/material/Stack';
// import Drawer from '@mui/material/Drawer';
// // hooks
// import { useResponsive } from 'src/hooks/use-responsive';
// // hooks
// import { useMockedUser } from 'src/hooks/use-mocked-user';
// // components
// import Logo from 'src/components/logo';
// import Scrollbar from 'src/components/scrollbar';
// import { usePathname } from 'src/routes/hooks';
// import { NavSectionVertical } from 'src/components/nav-section';
// //
// import { NAV } from '../config-layout';
// import { useNavData } from './config-navigation';
// import { NavToggleButton, NavUpgrade } from '../_common';

// // ----------------------------------------------------------------------

// type Props = {
//   openNav: boolean;
//   onCloseNav: VoidFunction;
// };

// export default function NavVertical({ openNav, onCloseNav }: Props) {
//   const { user } = useMockedUser();

//   const pathname = usePathname();

//   const lgUp = useResponsive('up', 'lg');

//   const navData = useNavData();

//   useEffect(() => {
//     if (openNav) {
//       onCloseNav();
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [pathname]);

//   const renderContent = (
//     <Scrollbar
//       sx={{
//         height: 1,
//         '& .simplebar-content': {
//           height: 1,
//           display: 'flex',
//           flexDirection: 'column',
//         },
//       }}
//     >
//       <Logo sx={{ mt: 3, ml: 4, mb: 1 }} />

//       <NavSectionVertical
//         data={navData}
//         config={{
//           currentRole: user?.role || 'admin',
//         }}
//       />

//       <Box sx={{ flexGrow: 1 }} />

//       <NavUpgrade />
//     </Scrollbar>
//   );

//   return (
//     <Box
//       component="nav"
//       sx={{
//         flexShrink: { lg: 0 },
//         width: { lg: NAV.W_VERTICAL },
//       }}
//     >
//       <NavToggleButton />

//       {lgUp ? (
//         <Stack
//           sx={{
//             height: 1,
//             position: 'fixed',
//             width: NAV.W_VERTICAL,
//             borderRight: (theme) => `dashed 1px ${theme.palette.divider}`,
//           }}
//         >
//           {renderContent}
//         </Stack>
//       ) : (
//         <Drawer
//           open={openNav}
//           onClose={onCloseNav}
//           PaperProps={{
//             sx: {
//               width: NAV.W_VERTICAL,
//             },
//           }}
//         >
//           {renderContent}
//         </Drawer>
//       )}
//     </Box>
//   );
// }













import { useContext, useEffect, useState } from 'react';
// @mui
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Drawer from '@mui/material/Drawer';
// hooks
import { AuthContext } from 'src/auth/context/jwt';
import { useResponsive } from 'src/hooks/use-responsive';
import Logo from 'src/components/logo';
import Scrollbar from 'src/components/scrollbar';
import { usePathname } from 'src/routes/hooks';
import { NavSectionVertical } from 'src/components/nav-section';
//
import { NAV } from '../config-layout';
import { useNavData } from './config-navigation';
import { NavToggleButton, NavUpgrade, SettingsButton } from '../_common';
// ---------------------------------------------

type Props = {
  openNav: boolean;
  onCloseNav: VoidFunction;
};

export default function NavVertical({ openNav, onCloseNav }: Props) {
  const pathname = usePathname();
  
  const lgUp = useResponsive('up', 'lg');
  const navData = useNavData();

  // console.log("vbncxmvbcxm",pathname)

  const { user } = useContext(AuthContext);
  // console.log('user', user); 
  const users = user && user;

  const conditionToShowRoles = users && users?.roles && users?.roles?.length > 0;
  const conditionToAdminuser = users && users.admin_users && users.admin_users.length > 0;
  const conditionToShowFacility =
    users && users.account_type_facility && users.account_type_facility.length > 0;
  const conditionToShowUser =
    users && users.account_type_user && users.account_type_user.length > 0;
  const conditionToProfessional =
    users && users.account_type_pro && users.account_type_pro.length > 0;
  const conditionToInsurance = users && users.insurance && users.insurance.length > 0;
  const conditionToReportedToPost =
    users && users.reported_to_post && users.reported_to_post.length > 0;
  const conditionTosubscription = users && users.subscription && users.subscription.length > 0;
  const conditionToadvertisement = users && users.advertisement && users.advertisement.length > 0;
  const conditionToMarketPlace = users && users.market_place && users.market_place.length > 0;

  // if (!conditionToShowRoles) {
  //   navData[0].items = navData[0].items.filter((item) => item.title !== 'access roles');
  // }

  if (!conditionToShowRoles) {
    navData[0].items.forEach((item) => {
      item.children = item.children
        ? item.children.filter((child) => child.title !== 'permissions')
        : undefined;
    });
  }
  
  // if (!conditionToAdminuser) {
  //   navData[0].items = navData[0].items.filter((item) => item.title !== 'admin user');
  // }

  if (!conditionToAdminuser) {
    navData[0].items.forEach((item) => {
      item.children = item.children
        ? item.children.filter(
            (child) =>
              child.title !== 'admin users' &&
              child.title !== 'delete permission' &&
              child.title !== 'chat permission'
          )
        : undefined;
    });
  }
  if (!conditionToShowFacility) {
    navData[0].items.forEach((item) => {
      item.children = item.children
        ? item.children.filter((child) => child.title !== 'facilities')
        : undefined;
    });
  }
  if (!conditionToShowUser) {
    navData[0].items.forEach((item) => {
      item.children = item.children
        ? item.children.filter((child) => child.title !== 'users')
        : undefined;
    });
  }
  if (!conditionToProfessional) {
    navData[0].items.forEach((item) => {
      item.children = item.children
        ? item.children.filter((child) => child.title !== 'professionals')
        : undefined;
    });
  }
  if (!conditionToShowFacility && !conditionToProfessional && !conditionToShowUser) {
    navData[0].items = navData[0].items.filter((item) => item.title !== 'Account type');
  }

  if (!conditionToShowRoles && !conditionToAdminuser ) {
    navData[0].items = navData[0].items.filter((item) => item.title !== 'Admin');
  }
  if (!conditionToInsurance) {
    navData[0].items.forEach((item) => {
      item.children = item.children
        ? item.children.filter((child) => child.title !== 'insurance' && child.title !== 'certificate')
        : undefined;
    });
  }
  if (!conditionToReportedToPost) {
    navData[0].items.forEach((item) => {
      item.children = item.children
        ? item.children.filter((child) => child.title !== 'moderated posts')
        : undefined;
    });
  }
  if (!conditionToInsurance && !conditionToReportedToPost) {
    navData[0].items = navData[0].items.filter((item) => item.title !== 'Verification');
  }
  if (!conditionTosubscription) {
    navData[0].items.forEach((item) => {
      item.children = item.children
        ? item.children.filter((child) => child.title !== 'subscriptions')
        : undefined;
    });
  }
  if (!conditionToMarketPlace) {
    navData[0].items.forEach((item) => {
      item.children = item.children
        ? item.children.filter((child) => child.title !== 'marketplace')
        : undefined;
    });
  }
  if (!conditionToadvertisement) {
    navData[0].items.forEach((item:any) => {
      item.children = item.children
        ? item.children.filter((child:any) => child.title !== 'advertisers')
        : undefined;
    });
  }
  if (!conditionTosubscription && !conditionToMarketPlace && !conditionToadvertisement) {
    navData[0].items = navData[0].items.filter((item:any) => item.title !== 'revenue');
  }

  useEffect(() => {
    
    if (openNav) {
      onCloseNav();      
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  //

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        '& .simplebar-content': {
          height: 1,
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >

      <Logo sx={{ mt: 3, ml: 4, mb: 1 }} />
      <NavSectionVertical
        data={navData}
        config={{
          currentRole: users && Object.keys(users).length > 0 ? Object.keys(users)[0] : '',
        }}
      />
      <Box sx={{ flexGrow: 1 }} />
      <SettingsButton  />
    </Scrollbar>
  );

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_VERTICAL },
      }}
    >
      {/* <NavToggleButton /> */}
      {lgUp ? (
        <Stack
          sx={{
            height: 1,
            position: 'fixed',
            width: NAV.W_VERTICAL,
            borderRight: (theme) => `dashed 1px ${theme.palette.divider}`,
          }}
        >
          {renderContent}
        </Stack>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          PaperProps={{
            sx: {
              width: NAV.W_VERTICAL,
            },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </Box>
  );
}
